// modules/EmailField.jsx
import React from "react";
import { Box, TextField, Button, Typography } from "@mui/material";

const EmailField = ({
  module,
  value,
  isEditable,
  onChange,
  fieldKey,
  confirmEmail,
  emailConfirmed,
  emailError,
}) => {
  return (
    <Box marginY={2}>
      <TextField
        label={module.label}
        value={value}
        onChange={(e) => onChange(fieldKey, e.target.value)}
        fullWidth
        required={module.required}
        margin="normal"
        type="email"
        InputProps={{
          readOnly: !isEditable,
        }}
        disabled={!isEditable}
      />
      {isEditable && (
        <Button
          variant="contained"
          color="secondary"
          onClick={confirmEmail}
          disabled={emailConfirmed}
          sx={{ marginTop: 1 }}
        >
          {emailConfirmed ? "Confirmed" : "Confirm"}
        </Button>
      )}
      {emailError && (
        <Typography variant="body2" color="error" sx={{ marginTop: 1 }}>
          {emailError}
        </Typography>
      )}
    </Box>
  );
};

export default EmailField;
